export function twitteTime(time) {
  var date = new Date(time * 1000);
  var now = new Date();
  if (
    date.getDate() + (date.getMonth() + 1) + date.getFullYear() ===
    now.getDate() + (now.getMonth() + 1) + now.getFullYear()
  ) {
    let spaceBhours = now.getHours() - date.getHours();
    if (spaceBhours > 2) {
      return `${spaceBhours} ساعت پیش`;
    } else {
      if (now.getMinutes() > date.getMinutes()) {
        if (now.getMinutes() == 0) {
          let spaceBminutes = Math.abs(60 - date.getMinutes());
          if (spaceBminutes >= 0 && spaceBminutes < 2) return "لحظاتی پیش";
          else if (spaceBminutes >= 2 && spaceBminutes < 10)
            return `${spaceBminutes} دقیقه پیش`;
          else if (spaceBminutes >= 10 && spaceBminutes < 15)
            return "یک ربع پیش";
          else if (spaceBminutes >= 15 && spaceBminutes < 30)
            return "نیم ساعت پیش";
          else if (spaceBminutes >= 30 && spaceBminutes < 45)
            return "45 دقیقه پیش";
        } else {
          let spaceBminutes = Math.abs(now.getMinutes() - date.getMinutes());
          console.log("spaceBminutes", spaceBminutes);
          if (spaceBminutes >= 0 && spaceBminutes < 2) return "لحظاتی پیش";
          else if (spaceBminutes >= 2 && spaceBminutes < 10)
            return `${spaceBminutes} دقیقه پیش`;
          else if (spaceBminutes >= 10 && spaceBminutes < 15)
            return "یک ربع پیش";
          else if (spaceBminutes >= 15 && spaceBminutes < 30)
            return "نیم ساعت پیش";
          else if (spaceBminutes >= 30 && spaceBminutes < 45)
            return "45 دقیقه پیش";
        }
      } else {
        return "1 ساعت پیش";
      }
    }
  } else {
    if (now.getMonth() + 1 == date.getMonth() + 1) {
      let spaceBdate = now.getDate() - date.getDate();
      return `${spaceBdate} روز پیش`;
    } else {
      return `${
        date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
      }`;
    }
  }
}
